import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {SharedService} from '../../services/shared.service';
import {Router} from '@angular/router';
import {OrderModel} from '../../models/order.model';
import {OrderService} from '../../services/order.service';

@Component({
  selector: 'app-reschedule-dialog',
  templateUrl: './reschedule-dialog.component.html',
  styleUrls: ['./reschedule-dialog.component.scss']
})
export class RescheduleDialogComponent {
  order: OrderModel;

  constructor(public dialogRef: MatDialogRef<RescheduleDialogComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private router: Router,
              private shared: SharedService,
              private orderService: OrderService) {
    this.order = data.order;
  }

  ngOnInit() {

  }

  seeOptions() {
    let order = {
      comments: this.order.comments,
      selectedHours: this.order.selectedHours,
      specs: this.order.specs,
      deliveryDate: this.order.deliveryDate
    };
    this.shared.setOrder(order, 'results');
    this.shared.addExcludedDistributor(this.order.distributor);
    this.shared.addRescheduleOrder(this.order);
    this.router.navigate(['account', 'request', 'results']);
    this.dialogRef.close();
  }

  accept() {
    this.orderService.updateOrder(this.order.id, {status: 1})
      .then(r => {
        this.dialogRef.close();
        this.router.navigate(['account', 'orders', 'details', this.order.id]);
      })
      .catch(error => {
        this.dialogRef.close();
        this.shared.openErrorDialog({title: 'Error', body: 'Unexpected error. Try again.'});
      });
  }

}
